<h1 class="mb-4">{{ "welcome1_title" | translate }} 👋</h1>
<p class="mb-12">{{ "welcome1_text1" | translate }}</p>

<div class="">
    <div class="">
        <div class="p-fluid">
            <div class="field">
                <label for="dropdownLanguage">
                    <strong>{{ "welcome1_language" | translate }} *</strong>
                </label>
                <p-select
                    inputId="dropdownLanguage"
                    [options]="languages"
                    [(ngModel)]="selectedLanguageCode"
                    optionLabel="name"
                    optionValue="code"
                    (onChange)="changeLanguage($event)"
                />
            </div>

            <div class="mb-8"></div>

            <p class="font-bold mb-4">{{ "welcome1_name" | translate }} *</p>
            <div class="field mb-4">
                <input
                    id="firstName"
                    [(ngModel)]="firstName"
                    (ngModelChange)="onFirstNameChange($event)"
                    autofocus
                    type="text"
                    class="p-inputtext-lg"
                    placeholder="{{ 'welcome1_first_name_placeholder' | translate }}"
                    pInputText
                    autocomplete="given-name"
                    (blur)="validateFirstName($event)"
                />
                <div class="flex flex-col field p-fluid">
                    @if (!!firstNameInvalid) {
                        <p-message class="mb-1" severity="error">{{ "welcome1_first_name_invalid" | translate }}</p-message>
                    }
                </div>
            </div>
            <div class="field mb-6">
                <input
                    id="lastName"
                    [(ngModel)]="lastName"
                    (ngModelChange)="onLastNameChange($event)"
                    type="text"
                    class="p-inputtext-lg"
                    placeholder="{{ 'welcome1_last_name_placeholder' | translate }}"
                    pInputText
                    autocomplete="family-name"
                    (blur)="validateLastName($event)"
                />
            </div>
            <div class="mb-6 flex flex-col field p-fluid">
                @if (!!lastNameInvalid) {
                    <p-message class="mb-1" severity="error">{{ "welcome1_last_name_invalid" | translate }}</p-message>
                }
            </div>

            <div class="mb-8"></div>

            <div class="field">
                <input type="text" class="hidden" autocomplete="username" />
                <label for="password">
                    <b>{{ "welcome1_password" | translate }} *</b>
                </label>
                <p-password
                    id="password"
                    size="large"
                    [(ngModel)]="password"
                    [toggleMask]="true"
                    placeholder="{{ 'welcome1_password_placeholder' | translate }}"
                />
            </div>
        </div>
    </div>
</div>

<div class="mb-20"></div>

<p-button label="{{ 'welcome1_button' | translate }}" (onClick)="goToNext()" [disabled]="firstName.length < 2 || lastName.length < 2 || password.length <= 6" />
